<template>
    <nio-modal
        name="templateCategory"
        size="sm"
        :title="$t('chat.templateCategory.category')"
        ref="modal"
        @closed="onClosed"
        @open="onOpen"
        @opened="onOpened"
    >
        <form class="space-y-6" @submit.prevent="onSave">
            <nio-input-group :label="$t('chat.templateCategory.name')">
                <nio-input ref="name" v-model="newName" />
            </nio-input-group>
        </form>

        <template #footer>
            <nio-button @click="close">
                {{ $t('chat.messageTemplate.close') }}
            </nio-button>
            <nio-button
                color="blue"
                :disabled="!valid"
                @click="onSave"
            >
                {{ $t('chat.messageTemplate.save') }}
            </nio-button>
        </template>
    </nio-modal>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        data() {
            return {
                newName: '',
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            ...mapState('chat', [
                'selectedTemplateCategory',
            ]),

            valid() {
                if (this.newName != null) {
                    if (this.newName.trim() === '') {
                        return false;
                    }
                }

                return true;
            },
        },

        methods: {
            ...mapActions('chat', [
                'fetchTemplateCategories',
            ]),

            init() {
                if (!this.selectedTemplateCategory) {
                    return;
                }

                this.newName = this.selectedTemplateCategory.name;
            },

            onSave() {
                const payload = {
                    name: this.newName,
                };

                if (this.selectedTemplateCategory.id != -1) {
                    this.update(payload);
                } else {
                    this.create(payload);
                }
            },

            async create(payload) {
                payload.account_id = this.authUser.account.id;

                try {
                    await this.$axios.post('categories', payload);

                    this.$notify.show({
                        type: 'success',
                        message: this.$t('chat.templateCategoryModal.successes.created'),
                    });

                    this.fetchTemplateCategories();
                    this.close();
                } catch (error) {
                    this.$notify.show({
                        type: 'error',
                        message: this.$t('chat.templateCategoryModal.errors.creating'),
                    });

                    throw error;
                }
            },

            async update(payload) {
                try {
                    await this.$axios.put(`categories/${this.selectedTemplateCategory.id}`, payload);

                    this.$notify.show({
                        type: 'success',
                        message: this.$t('chat.templateCategoryModal.successes.updated'),
                    });

                    this.fetchTemplateCategories();
                    this.close();
                } catch (error) {
                    this.$notify.show({
                        type: 'error',
                        message: this.$t('chat.templateCategoryModal.errors.updating'),
                    });

                    throw error;
                }
            },

            close() {
                this.$refs.modal.close();
            },

            onOpen() {
                this.init();
            },

            onOpened() {
                this.$refs.name.focus();
            },

            onClosed() {
                this.$reset();
            },
        },
    };
</script>
